// extracted by mini-css-extract-plugin
export var btn = "B_mB p_rl p_qY d_bz d_bP d_bD d_dw";
export var full = "B_tT d_w d_H";
export var hoverStyle = "B_mF";
export var zoom = "B_mG";